export enum ForProject {
  LIHP = 'LIHP',
  LOHP = 'LOHP',
  ALL = 'ALL',
}
